import { Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';


@Component({
  templateUrl: './listado.initializer.component.html'
})
export class ListadoInitializerComponent implements OnInit {
  public itemOver: String;
  constructor(private router: Router, private aRoute: ActivatedRoute) { }

  ngOnInit() {

  }
  volver() {
      this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/initializer/listado.initializer.component.ts